var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1091.75 1091.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .1;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #333;\n      }\n\n      .cls-5 {\n        fill: #f9aa4d;\n      }\n\n      .cls-6, .cls-7 {\n        fill: #f7931e;\n      }\n\n      .cls-8, .cls-9 {\n        fill: #f5f5f7;\n      }\n\n      .cls-10 {\n        fill: #999;\n      }\n\n      .cls-11 {\n        fill: #666;\n      }\n\n      .cls-12 {\n        fill: #8d8d8d;\n      }\n\n      .cls-13 {\n        fill: #a9a9a9;\n      }\n\n      .cls-14 {\n        fill: #d8d8d8;\n      }\n\n      .cls-15 {\n        fill: #c4c4c4;\n      }\n\n      .cls-16 {\n        fill: #606060;\n      }\n\n      .cls-3, .cls-7, .cls-9 {\n        opacity: .2;\n      }\n\n      .cls-4 {\n        opacity: .4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    width: 1091.75,
    height: 1091.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m419.4,851.79h227.65c1.44,0,2.6,1.17,2.6,2.6v9.11c0,1.43-1.17,2.6-2.6,2.6h-227.65c-1.44,0-2.6-1.17-2.6-2.6v-9.1c0-1.44,1.17-2.6,2.6-2.6Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m574.68,784.3h-82.9c0,37.66-56.62,69.4-56.62,69.4h196.14s-56.62-31.73-56.62-69.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m574.68,784.3h-60.59c11.79,21.85,32.39,48.73,67.64,69.4h49.56s-56.62-31.73-56.62-69.4Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 181.25,
    y: 354.49,
    width: 703.94,
    height: 429.81,
    rx: 4.51,
    ry: 4.51
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 207.87,
    y: 378.18,
    width: 650.72,
    height: 382.43,
    rx: 4.51,
    ry: 4.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m858.58,409.19v-26.5c0-2.48-2.03-4.51-4.51-4.51H212.38c-2.48,0-4.51,2.03-4.51,4.51v26.5h650.72Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 254.82,
    cy: 393.69,
    r: 6.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 227.75,
    cy: 393.69,
    r: 6.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-11",
    cx: 281.9,
    cy: 393.69,
    r: 6.51
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.99,
    y: 433.23,
    width: 552.48,
    height: 111.34
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 256.99,
    y: 562.62,
    width: 232.76,
    height: 74.19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.99,
    y: 653.23,
    width: 232.76,
    height: 10.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.99,
    y: 675.79,
    width: 232.76,
    height: 10.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.99,
    y: 698.36,
    width: 232.76,
    height: 10.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 256.99,
    y: 720.92,
    width: 232.76,
    height: 10.95
  })))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 510.66,
    y: 562.62,
    width: 115.07,
    height: 124.12
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 509.35,
    y: 698.36,
    width: 116.2,
    height: 10.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 509.35,
    y: 720.92,
    width: 116.2,
    height: 10.95
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 649.65,
    y: 562.62,
    width: 159.81,
    height: 74.19
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 649.65,
    y: 653.23,
    width: 157.03,
    height: 10.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 649.65,
    y: 675.79,
    width: 157.03,
    height: 10.95
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 649.65,
    y: 698.36,
    width: 157.03,
    height: 10.95
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 649.65,
    y: 720.92,
    width: 157.03,
    height: 10.95
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m885.2,779.78v-420.78c0-2.48-2.03-4.51-4.51-4.51h-61.06c-18.69,335.02-357.85,429.81-357.85,429.81h418.91c2.48,0,4.51-2.03,4.51-4.51Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m240.05,645.18c-2.48,0-5.12,1.93-5.86,4.31l-8.58,27.41c-.74,2.37-3.38,4.31-5.86,4.31h-94.01c-2.48,0-4.15,2-3.71,4.44l27.73,153.46c.44,2.44,2.83,4.44,5.31,4.44h148.92c2.48,0,4.81-2.01,5.17-4.46l28.01-189.43c.36-2.45-1.37-4.46-3.85-4.46h-93.27Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "305.17 793.52 154 793.52 154 579.17 276.16 579.17 305.17 608.5 305.17 793.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "276.16 579.17 305.17 608.5 276.16 608.5 276.16 579.17"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 167.91,
    y: 635.95,
    width: 123.35,
    height: 3.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 167.91,
    y: 650.14,
    width: 123.35,
    height: 3.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 167.91,
    y: 664.33,
    width: 123.35,
    height: 3.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 167.91,
    y: 678.51,
    width: 123.35,
    height: 3.55
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 167.91,
    y: 692.7,
    width: 123.35,
    height: 3.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 167.91,
    y: 706.88,
    width: 123.35,
    height: 3.55
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 189.94,
    y: 598.83,
    width: 86.21,
    height: 19.32
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m240.05,667.74c-2.48,0-5.12,1.93-5.86,4.31l-8.58,27.41c-.74,2.37-3.38,4.31-5.86,4.31h-94.01c-2.48,0-4.15,2-3.71,4.44l27.73,153.46c.44,2.44,2.83,4.44,5.31,4.44h148.92c2.48,0,4.81-2.01,5.17-4.46l28.01-189.43c.36-2.45-1.37-4.46-3.85-4.46h-93.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m309.16,861.64l28.01-189.43c.36-2.45-1.37-4.46-3.85-4.46h-9.04c-15.15,144.04-124.05,179.67-175.51,188.47l.98,5.44c.44,2.44,2.83,4.44,5.31,4.44h148.92c2.48,0,4.81-2.01,5.17-4.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m695.17,659.66h271.36c2.39,0,4.33,1.94,4.33,4.33v197.11c0,2.39-1.94,4.34-4.34,4.34h-271.35c-2.39,0-4.34-1.94-4.34-4.34v-197.11c0-2.39,1.94-4.34,4.34-4.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m705.83,667.74h250.05c2.2,0,3.99,1.79,3.99,3.99v166.46c0,2.2-1.79,3.99-3.99,3.99h-250.05c-2.2,0-3.99-1.79-3.99-3.99v-166.46c0-2.21,1.79-4,4-4Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m959.87,852.97c0,.84-.68,1.52-1.53,1.52h-254.99c-.84,0-1.53-.68-1.53-1.52h0c0-.84.68-1.52,1.53-1.52h254.99c.84,0,1.53.68,1.53,1.52h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m873.16,852.97c0,.84-.69,1.52-1.53,1.52h-168.28c-.84,0-1.53-.68-1.53-1.52h0c0-.84.68-1.52,1.53-1.52h168.28c.84,0,1.53.68,1.53,1.52h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m877.05,853.14c0,3.29-2.67,5.96-5.96,5.96s-5.96-2.67-5.96-5.96,2.67-5.96,5.96-5.96,5.96,2.67,5.96,5.96Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m899.5,757.41c0,37.91-30.73,68.65-68.65,68.65s-68.65-30.74-68.65-68.65,30.74-68.65,68.65-68.65,68.65,30.73,68.65,68.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m884.5,757.41c0,29.63-24.02,53.65-53.65,53.65s-53.65-24.02-53.65-53.65,24.02-53.65,53.65-53.65,53.65,24.02,53.65,53.65Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "820.25 734.92 820.25 779.9 849.56 757.88 820.25 734.92"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m966.53,865.44c2.38,0,4.34-1.95,4.34-4.34v-197.11c0-2.38-1.95-4.34-4.34-4.34h-25.42c.02,136.5-70.36,187.98-108.21,205.78h133.63Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 490.34,
    y: 233.81,
    width: 277.4,
    height: 184.09,
    rx: 2.22,
    ry: 2.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 500.43,
    y: 244.58,
    width: 257.21,
    height: 162.56,
    rx: 2.02,
    ry: 2.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m701.61,300.18c-5.87-6.79-15.47-6.79-21.34,0l-72.46,83.82c-5.87,6.78-15.47,6.78-21.34,0l-32.95-38.13c-5.86-6.79-15.47-6.79-21.34,0l-31.75,36.73v24.65c0,1.11.91,2.02,2.02,2.02h253.16c1.12,0,2.02-.91,2.02-2.02v-42.26l-56.03-64.81Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m617.61,293.16c0,14.74-11.95,26.69-26.69,26.69s-26.69-11.95-26.69-26.69,11.95-26.69,26.69-26.69,26.69,11.95,26.69,26.69Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m765.52,417.9c1.22,0,2.22-1,2.22-2.22v-179.66c0-1.22-1-2.22-2.22-2.22h-32.36c-5.85,107.89-49.65,159.53-87.13,184.09h119.48Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m344.14,458.05h183.78c1.33,0,2.4,1.08,2.4,2.4v131.16c0,1.33-1.08,2.4-2.4,2.4h-183.78c-1.33,0-2.4-1.08-2.4-2.4v-131.16c0-1.33,1.08-2.41,2.41-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m530.33,474.57v-14.11c0-1.32-1.08-2.4-2.41-2.4h-183.78c-1.32,0-2.4,1.08-2.4,2.4v14.11h188.59Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m370.21,466.31c0,1.91-1.55,3.47-3.46,3.47s-3.47-1.55-3.47-3.47,1.55-3.47,3.47-3.47,3.46,1.55,3.46,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m355.79,466.31c0,1.91-1.55,3.47-3.46,3.47s-3.47-1.55-3.47-3.47,1.55-3.47,3.47-3.47,3.46,1.55,3.46,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m384.63,466.31c0,1.91-1.55,3.47-3.46,3.47s-3.47-1.55-3.47-3.47,1.55-3.47,3.47-3.47,3.46,1.55,3.46,3.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 395.17,
    y: 507.53,
    width: 121.68,
    height: 4.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 355.21,
    y: 491.74,
    width: 36.08,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 355.21,
    y: 523.33,
    width: 19.09,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 355.21,
    y: 539.12,
    width: 36.08,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 355.21,
    y: 554.92,
    width: 28.07,
    height: 4.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 411.92,
    y: 491.74,
    width: 70.07,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 355.21,
    y: 507.53,
    width: 28.07,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 382.4,
    y: 523.33,
    width: 82.79,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 411.92,
    y: 539.12,
    width: 70.07,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 395.17,
    y: 554.92,
    width: 121.68,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 355.21,
    y: 570.71,
    width: 19.09,
    height: 4.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 382.4,
    y: 570.71,
    width: 82.79,
    height: 4.89
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m530.33,460.46c0-1.32-1.08-2.4-2.41-2.4h-45.1c-1.09,84.09-58.68,122.67-85.14,135.97h130.25c1.32,0,2.41-1.08,2.41-2.41v-131.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m661.98,387.81h161.22c1.33,0,2.4,1.08,2.4,2.4v86.03c0,1.33-1.08,2.4-2.4,2.4h-161.22c-1.33,0-2.41-1.08-2.41-2.41v-86.03c0-1.33,1.08-2.41,2.41-2.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m825.6,404.33v-14.11c0-1.32-1.08-2.4-2.41-2.4h-161.22c-1.32,0-2.4,1.08-2.4,2.4v14.11h166.03Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m688.04,396.07c0,1.91-1.55,3.47-3.46,3.47s-3.47-1.55-3.47-3.47,1.55-3.47,3.47-3.47,3.46,1.55,3.46,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m673.62,396.07c0,1.91-1.55,3.47-3.46,3.47s-3.47-1.55-3.47-3.47,1.55-3.47,3.47-3.47,3.46,1.55,3.46,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m702.46,396.07c0,1.91-1.55,3.47-3.46,3.47s-3.47-1.55-3.47-3.47,1.55-3.47,3.47-3.47,3.46,1.55,3.46,3.47Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m746.47,422.16c-3.78,11.44-7.56,22.89-11.33,34.33-.75,2.27,2.82,3.23,3.56.98,3.78-11.44,7.56-22.88,11.34-34.32.75-2.27-2.82-3.23-3.57-.98h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m732.81,446.26c-3.12-2.15-6.25-4.3-9.38-6.45,3.13-2.15,6.26-4.3,9.38-6.45,1.95-1.34.11-4.54-1.87-3.19-3.9,2.68-7.8,5.37-11.7,8.04-1.19.82-1.19,2.38,0,3.19,3.9,2.68,7.8,5.36,11.7,8.05,1.97,1.35,3.82-1.85,1.87-3.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m752.36,446.26c3.12-2.15,6.25-4.3,9.37-6.45-3.13-2.15-6.25-4.3-9.37-6.45-1.95-1.34-.1-4.54,1.86-3.19,3.9,2.68,7.8,5.37,11.7,8.04,1.19.82,1.19,2.38,0,3.19-3.9,2.68-7.8,5.36-11.7,8.05-1.97,1.35-3.81-1.85-1.86-3.19Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m823.19,478.65c1.32,0,2.41-1.08,2.41-2.41v-86.03c0-1.32-1.08-2.4-2.41-2.4h-36.09c-2.73,53.39-33.2,78.87-58.27,90.84h94.36Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m907,625.72l-2.48,6.05-38.9-15.98c11.12-32.21-4.68-68-36.59-81.11-33.08-13.6-71.05,2.26-84.65,35.34-13.59,33.08,2.26,71.06,35.35,84.65,31.91,13.11,68.31-1.22,83.05-31.95l38.9,15.98-2.49,6.04,38.42,15.79,7.82-19.03-38.42-15.79Zm-51.87-10.19c-11.5,27.98-43.62,41.39-71.61,29.89-27.98-11.49-41.39-43.62-29.89-71.6,11.5-27.98,43.62-41.39,71.61-29.9,27.98,11.5,41.39,43.62,29.89,71.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m786.73,555.22c-6.13,2.56-9.03,9.6-6.46,15.73,2.56,6.13,9.6,9.03,15.73,6.47,6.13-2.56,9.03-9.61,6.47-15.74-2.56-6.13-9.61-9.03-15.74-6.46Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1002.77,366.78h-8.98c-1.09-7.52-4.04-14.42-8.38-20.23l6.35-6.35c.88-.88.88-2.31,0-3.19l-5.96-5.96c-.88-.88-2.31-.88-3.19,0l-6.35,6.35c-5.82-4.34-12.72-7.29-20.23-8.38v-8.99c0-1.24-1.02-2.26-2.26-2.26h-8.42c-1.24,0-2.26,1.02-2.26,2.26v8.99c-7.52,1.09-14.41,4.04-20.23,8.38l-6.35-6.35c-.88-.88-2.31-.88-3.19,0l-5.96,5.96c-.88.88-.88,2.31,0,3.19l6.35,6.35c-4.34,5.82-7.29,12.72-8.38,20.23h-8.98c-1.24,0-2.26,1.02-2.26,2.26v8.42c0,1.24,1.01,2.26,2.26,2.26h8.98c1.09,7.52,4.04,14.41,8.38,20.23l-6.35,6.35c-.88.88-.88,2.31,0,3.19l5.96,5.96c.88.88,2.31.88,3.19,0l6.35-6.35c5.82,4.34,12.72,7.29,20.23,8.38v8.98c0,1.24,1.02,2.26,2.26,2.26h8.42c1.24,0,2.26-1.01,2.26-2.26v-8.98c7.52-1.09,14.42-4.04,20.24-8.38l6.35,6.35c.88.88,2.31.88,3.19,0l5.96-5.96c.88-.88.88-2.31,0-3.19l-6.35-6.35c4.34-5.82,7.29-12.72,8.38-20.24h8.98c1.24,0,2.26-1.02,2.26-2.26v-8.42c0-1.24-1.01-2.26-2.26-2.26Zm-53.21,39.19c-18.07,0-32.72-14.65-32.72-32.72s14.65-32.72,32.72-32.72,32.72,14.65,32.72,32.72-14.65,32.72-32.72,32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m912.68,279.88h-7.12c-.86-5.96-3.2-11.43-6.65-16.04l5.04-5.04c.7-.69.7-1.83,0-2.53l-4.72-4.72c-.7-.7-1.84-.7-2.53,0l-5.03,5.03c-4.61-3.44-10.08-5.78-16.04-6.64v-7.12c0-.98-.81-1.79-1.79-1.79h-6.68c-.98,0-1.79.81-1.79,1.79v7.12c-5.96.87-11.43,3.2-16.05,6.65l-5.03-5.04c-.7-.7-1.83-.69-2.53,0l-4.72,4.72c-.7.69-.7,1.83,0,2.53l5.04,5.04c-3.44,4.62-5.78,10.08-6.64,16.04h-7.12c-.98,0-1.79.81-1.79,1.79v6.68c0,.98.8,1.79,1.79,1.79h7.12c.86,5.96,3.2,11.43,6.64,16.04l-5.04,5.03c-.7.7-.7,1.84,0,2.53l4.72,4.72c.7.7,1.83.7,2.53,0l5.03-5.04c4.61,3.45,10.08,5.78,16.05,6.65v7.12c0,.99.8,1.79,1.79,1.79h6.68c.98,0,1.79-.8,1.79-1.79v-7.12c5.96-.86,11.43-3.2,16.05-6.64l5.03,5.03c.7.7,1.84.7,2.53,0l4.72-4.72c.7-.69.7-1.83,0-2.53l-5.03-5.03c3.44-4.62,5.78-10.08,6.64-16.05h7.12c.98,0,1.79-.8,1.79-1.79v-6.68c0-.98-.8-1.79-1.79-1.79Zm-42.19,22.91c-9.82,0-17.78-7.96-17.78-17.78s7.96-17.78,17.78-17.78,17.78,7.96,17.78,17.78-7.96,17.78-17.78,17.78Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m406.36,860.38c.12,5.33-4.13,9.68-9.46,9.68h-4.75c-5.33,0-9.58-4.35-9.46-9.68l3.42-147.21c.12-5.32,3.91-9.68,8.41-9.68s8.29,4.36,8.41,9.68l3.42,147.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m392.15,870.06h4.75c1.71,0,3.29-.48,4.67-1.27l-1.62-69.74c-.08-3.43-2.52-6.24-5.42-6.24s-5.34,2.81-5.42,6.24l-1.62,69.74c1.38.79,2.96,1.27,4.67,1.27Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m414.44,651.15v27.14l-19.91,19.65-19.91-19.65v-27.14c-13.87,7.21-23.34,21.69-23.34,38.39,0,23.89,19.37,43.26,43.26,43.26s43.26-19.37,43.26-43.26c0-16.71-9.48-31.19-23.34-38.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m394.52,724.41c-15.94,0-30.22-7.06-39.92-18.2,6.53,15.61,21.94,26.59,39.92,26.59s33.4-10.97,39.92-26.59c-9.71,11.14-23.99,18.2-39.92,18.2Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 249.78,
    y: 251.23,
    width: 186.96,
    height: 104.12,
    rx: 6.18,
    ry: 6.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m430.56,251.23h-174.6c-.87,0-1.7.19-2.45.52l84.02,60.88c3.15,2.28,8.31,2.28,11.46,0l84.02-60.88c-.75-.33-1.58-.52-2.45-.52Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m430.56,251.23h-31.5c-7.75,64.72-58.45,92.39-96.8,104.12h128.3c3.4,0,6.18-2.78,6.18-6.18v-91.75c0-3.4-2.78-6.18-6.18-6.18Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m347.71,165.94c-16.77,34.6-54.28,42.29-54.28,42.29,7.21,61.52,54.28,74.33,54.28,74.33,0,0,47.07-12.82,54.28-74.33,0,0-37.51-7.69-54.28-42.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m347.71,193.38c-10.22,21.09-33.08,25.77-33.08,25.77,4.39,37.49,33.08,45.3,33.08,45.3,0,0,28.69-7.81,33.08-45.3,0,0-22.86-4.68-33.08-25.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m362.13,219.18c-4.97,6.17-9.94,12.33-14.92,18.49-3.19-2.42-6.38-4.84-9.57-7.27-3-2.28-5.91,2.8-2.95,5.04,3.85,2.92,7.69,5.84,11.54,8.76.95.72,2.79.47,3.54-.46,5.5-6.81,10.99-13.62,16.49-20.44,2.34-2.9-1.76-7.06-4.13-4.13Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m199.12,444.6c-3.34,0-6.56.52-9.59,1.5-4.67-18.68-21.55-32.5-41.67-32.5-23.73,0-42.96,19.23-42.96,42.96,0,1.73.11,3.43.31,5.1-1.49-.31-3.05-.47-4.63-.47-12.81,0-23.2,10.39-23.2,23.2s10.39,23.2,23.2,23.2h98.53c17.4,0,31.5-14.1,31.5-31.5s-14.1-31.5-31.5-31.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m215.19,449.05c1.98,4.12,3.12,8.72,3.12,13.6,0,17.4-14.11,31.49-31.5,31.49h-98.53c-3.42,0-6.65-.75-9.57-2.08,3.17,9.04,11.76,15.54,21.88,15.54h98.53c17.4,0,31.5-14.1,31.5-31.5,0-11.52-6.2-21.56-15.43-27.05Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "178.26 467.16 168.46 454.66 158.67 467.16 164.63 467.16 164.63 477.02 172.3 477.02 172.3 467.16 178.26 467.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "125.22 466.46 135.02 478.97 144.82 466.46 138.86 466.46 138.86 456.61 131.19 456.61 131.19 466.46 125.22 466.46"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m770.8,204.65c-3.16,0-6.19.5-9.04,1.41-4.4-17.61-20.32-30.65-39.29-30.65-22.38,0-40.51,18.13-40.51,40.51,0,1.63.1,3.23.29,4.81-1.41-.29-2.87-.44-4.36-.44-12.09,0-21.88,9.8-21.88,21.88s9.8,21.87,21.88,21.87h92.92c16.4,0,29.71-13.29,29.71-29.7s-13.3-29.7-29.71-29.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m785.95,208.84c1.86,3.89,2.94,8.23,2.94,12.83,0,16.4-13.3,29.7-29.7,29.7h-92.92c-3.22,0-6.27-.71-9.03-1.96,2.99,8.53,11.09,14.65,20.64,14.65h92.92c16.4,0,29.71-13.29,29.71-29.7,0-10.86-5.85-20.34-14.55-25.51Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "737.5 221.35 725.54 206.09 713.58 221.35 720.86 221.35 720.86 233.38 730.22 233.38 730.22 221.35 737.5 221.35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m980.16,518.94c-2.2,0-4.31.35-6.3.99-3.07-12.26-14.15-21.34-27.36-21.34-15.58,0-28.21,12.62-28.21,28.2,0,1.14.07,2.25.2,3.35-.98-.2-2-.31-3.04-.31-8.41,0-15.23,6.83-15.23,15.23s6.82,15.23,15.23,15.23h64.69c11.42,0,20.68-9.25,20.68-20.68s-9.26-20.68-20.68-20.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m990.71,521.86c1.3,2.71,2.05,5.73,2.05,8.93,0,11.42-9.26,20.68-20.68,20.68h-64.69c-2.24,0-4.36-.5-6.28-1.37,2.08,5.94,7.72,10.2,14.37,10.2h64.69c11.42,0,20.68-9.25,20.68-20.68,0-7.56-4.07-14.15-10.13-17.76Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "939.15 528.26 947.97 539.51 956.79 528.26 951.42 528.26 951.42 519.39 944.52 519.39 944.52 528.26 939.15 528.26"
  })))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 545.88,
    cy: 905.69,
    rx: 534.13,
    ry: 20.12
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset1);
export default __webpack_public_path__ + "static/media/Asset 1.6653f3abf61379335cf1e6171d9303d2.svg";
export { ForwardRef as ReactComponent };